import { addLead } from "../services/api.js";

document.addEventListener("DOMContentLoaded", () => {
    const standaloneInquiryForm = document.getElementById("standaloneInquiryForm");
    if (!standaloneInquiryForm) return;

    const nameInput = document.getElementById("inq_name");
    const schoolInput = document.getElementById("inq_school");
    const phoneInput = document.getElementById("inq_phone");
    const emailInput = document.getElementById("inq_email");
    const cityInput = document.getElementById("inq_city");
    const stateInput = document.getElementById("inq_state");
    const commentInput = document.getElementById("inq_comment");

    // Helper: Mark field as invalid with a message
    const setFieldError = (input, message) => {
        if (!input) return;
        input.classList.add("is-invalid");
        const feedback = input.parentElement.querySelector(".invalid-feedback");
        if (feedback) {
            feedback.textContent = message;
            feedback.style.display = "block";
        }
    };

    // Helper: Clear field error state
    const clearFieldError = (input) => {
        if (!input) return;
        input.classList.remove("is-invalid");
        const feedback = input.parentElement.querySelector(".invalid-feedback");
        if (feedback) {
            feedback.style.display = "";
        }
    };

    // Real-time error clearing when user edits any field
    [nameInput, schoolInput, phoneInput, emailInput, cityInput, stateInput].forEach((input) => {
        if (input) {
            input.addEventListener("input", () => clearFieldError(input));
            input.addEventListener("change", () => clearFieldError(input));
        }
    });

    // Real-time input restriction: only alphabets and spaces allowed in Name
    if (nameInput) {
        nameInput.addEventListener("input", (e) => {
            e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
        });
    }

    // Real-time input restriction: only numbers, +, spaces, and dashes allowed in Phone
    if (phoneInput) {
        phoneInput.addEventListener("input", (e) => {
            e.target.value = e.target.value.replace(/[^0-9+\s\-]/g, "");
        });
    }

    // Real-time input restriction: only alphabets and spaces in City and State
    if (cityInput) {
        cityInput.addEventListener("input", (e) => {
            e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
        });
    }

    if (stateInput) {
        stateInput.addEventListener("input", (e) => {
            e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
        });
    }

    // Validate a single field
    const validateField = (input) => {
        if (!input) return true;
        const val = input.value.trim();
        const id = input.id;

        if (id === "inq_name") {
            if (!val) {
                setFieldError(input, "Name is required.");
                return false;
            }
            if (!/^[a-zA-Z\s]{2,}$/.test(val)) {
                setFieldError(input, "Please enter a valid name (alphabets only).");
                return false;
            }
        } else if (id === "inq_school") {
            if (!val) {
                setFieldError(input, "School Name is required.");
                return false;
            }
            if (val.length < 2) {
                setFieldError(input, "Please enter a valid school name.");
                return false;
            }
        } else if (id === "inq_phone") {
            if (!val) {
                setFieldError(input, "Phone Number is required.");
                return false;
            }
            const digitsOnly = val.replace(/\D/g, "");
            const isValidPhone = (
                (digitsOnly.length === 10 && /^[6-9]\d{9}$/.test(digitsOnly)) ||
                (digitsOnly.length === 11 && digitsOnly.startsWith("0") && /^[6-9]\d{9}$/.test(digitsOnly.slice(1))) ||
                (digitsOnly.length === 12 && digitsOnly.startsWith("91") && /^[6-9]\d{9}$/.test(digitsOnly.slice(2))) ||
                (digitsOnly.length >= 10 && digitsOnly.length <= 15)
            );
            if (!isValidPhone) {
                setFieldError(input, "Please enter a valid 10-digit mobile number.");
                return false;
            }
        } else if (id === "inq_email") {
            if (!val) {
                setFieldError(input, "Email is required.");
                return false;
            }
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(val)) {
                setFieldError(input, "Please enter a valid email address.");
                return false;
            }
        } else if (id === "inq_city") {
            if (!val) {
                setFieldError(input, "City is required.");
                return false;
            }
            if (val.length < 2) {
                setFieldError(input, "Please enter a valid city.");
                return false;
            }
        } else if (id === "inq_state") {
            if (!val) {
                setFieldError(input, "State is required.");
                return false;
            }
            if (val.length < 2) {
                setFieldError(input, "Please enter a valid state.");
                return false;
            }
        }

        clearFieldError(input);
        return true;
    };

    standaloneInquiryForm.addEventListener("submit", async (e) => {
        e.preventDefault();

        // Validate all required fields
        const requiredInputs = [nameInput, schoolInput, phoneInput, emailInput, cityInput, stateInput];
        let hasErrors = false;
        let firstInvalidInput = null;

        for (const input of requiredInputs) {
            if (!validateField(input)) {
                hasErrors = true;
                if (!firstInvalidInput) {
                    firstInvalidInput = input;
                }
            }
        }

        if (hasErrors) {
            if (firstInvalidInput) {
                firstInvalidInput.focus();
            }
            Swal.fire({
                icon: "warning",
                title: "Missing or Invalid Fields",
                text: "Please fill out all the required (*) fields correctly before submitting.",
                timer: 4000
            });
            return;
        }

        const name = nameInput.value.trim();
        const school_name = schoolInput.value.trim();
        const phone_number = phoneInput.value.trim();
        const email = emailInput.value.trim();
        const city = cityInput.value.trim();
        const state = stateInput.value.trim();
        const comment = commentInput ? commentInput.value.trim() : "";

        // reCAPTCHA v3 Execution
        let captchaToken = "";
        try {
            if (typeof grecaptcha !== 'undefined') {
                captchaToken = await new Promise((resolve) => {
                    grecaptcha.ready(() => {
                        grecaptcha.execute("6LcejPstAAAAAGHxCSTCuORbslzszxECU4Tj2h5W", { action: "inquiry_submit" })
                            .then(resolve)
                            .catch((err) => {
                                console.warn("reCAPTCHA v3 error:", err);
                                resolve("");
                            });
                    });
                });
            }
        } catch (e) {
            console.warn("Captcha verification ignored or not initialized properly.", e);
        }

        const submitButton = standaloneInquiryForm.querySelector("[type='submit']");
        submitButton.classList.add("loading");

        const payload = {
            name,
            phone_number,
            school_name,
            email,
            city,
            state,
            leads_remarks: comment,
            recaptcha_token: captchaToken || undefined
        };

        const removeEmptyValues = (obj) => {
            return Object.fromEntries(
                Object.entries(obj).filter(([_, value]) => {
                    if (value === null || value === undefined || value === '') {
                        return false;
                    }
                    return true;
                })
            );
        };

        try {
            const cleanPayload = removeEmptyValues(payload);
            const res = await addLead(cleanPayload);
            console.log("API Response:", res);

            if (Object.keys(res).length > 0) {
                if (localStorage.getItem("downloadbrochure") === "true") {
                    const anchor = document.createElement('a');
                    anchor.href = 'assets/pdf/Cogno-Brochure.pdf';
                    anchor.download = 'Cogno-Brochure';
                    document.body.appendChild(anchor);
                    anchor.click();
                    document.body.removeChild(anchor);
                }

                standaloneInquiryForm.reset();

                setTimeout(() => {
                    window.location.href = "thank-you.html";
                }, 500);
            }
        } catch (error) {
            console.error("API Error:", error);
            Swal.fire({
                title: "Oops...",
                text: `${error?.response?.data?.issues?.message}` || "Something went wrong!",
                icon: "error",
                showConfirmButton: true,
            });
        } finally {
            submitButton.classList.remove("loading");
        }
    });
});
